module.exports = __webpack_public_path__ + "img/etri.184899c7.png";